import type { NewConfirmationSelectOption } from "../types/new-confirmation.types";

/** Monedas stablecoin que usan método crypto (wallet) en cuentas y pagos. */
const CRYPTO_WALLET_CURRENCY_SET = new Set(["USDT", "USDC"]);

export function isCryptoWalletCurrency(code: string): boolean {
  return CRYPTO_WALLET_CURRENCY_SET.has(code.trim());
}

export const CURRENCY_OPTIONS: NewConfirmationSelectOption[] = [
  { label: "Peso Colombiano (COP)", value: "COP" },
  { label: "Real Brasileño (BRL)", value: "BRL" },
  { label: "Peso Mexicano (MXN)", value: "MXN" },
  { label: "Peso Chileno (CLP)", value: "CLP" },
  { label: "Sol Peruano (PEN)", value: "PEN" },
  { label: "Guaraní Paraguayo (PYG)", value: "PYG" },
  { label: "Peso Uruguayo (UYU)", value: "UYU" },
  { label: "Dólar Estadounidense (USD)", value: "USD" },
  { label: "Euro (EUR)", value: "EUR" },
  { label: "Dólar de Hong Kong (HKD)", value: "HKD" },
  { label: "Yuan Chino (CNY)", value: "CNY" },
  { label: "Colón Costarricense (CRC)", value: "CRC" },
  { label: "Peso Argentino (ARS)", value: "ARS" },
  { label: "Quetzal Guatemalteco (GTQ)", value: "GTQ" },
  { label: "USDT - Activo Digital (USDT)", value: "USDT" },
  { label: "USDC - Activo digital (USDC)", value: "USDC" },
];

export function getCurrencyLabel(code: string): string {
  const option = CURRENCY_OPTIONS.find((opt) => opt.value === code);
  return option?.label ?? code;
}
